import joinClassNames from "utils-lib/joinClassNames"
import "./InfoMessage.scss"

export default function InfoMessage({ children }) {
  return (
    <div
      className={joinClassNames([
        `InfoMessage`,
        children[1] ? children[1] : ``,
      ])}
    >
      {/* children[1] ?<ReactSVG wrapper="span"src={errorExclamatoryOrangeBg} /> : null */}
      <span className="errorMsg maax-font-weight-regular">
        {children.length > 0 ? children[0] : children}
      </span>
    </div>
  )
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// InfoMessage.propTypes = {
//   children: PropTypes.any.isRequired,
// }
